import { HttpClient, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class GravatarAPIService {
    constructor(private http: HttpClient) {}
    // Currently only logging the hash because having trouble building
    checkGravatar(hashedEmail: string) {
        return this.http
            .get(`https://gravatar.com/avatar/${hashedEmail}.json?d=404`)
            .pipe(
                // Fix this map later when not in a time crunch (note he said this on 5/23/23 and this will probably never be fixed)
                map((response) => true),
                catchError(async (err) => {
                    if (err.status === HttpStatusCode.NotFound) {
                        return false;
                    } else if (err.status === HttpStatusCode.Ok) {
                        return true;
                    }
                })
            );
    }
}
